import React from "react";

const Footer = () => {
  return (
    <footer className="text-center p-4 footer" style={{ backgroundColor: "#eff1f4" }}>
      <p className="mb-1">
        All Programs Listed here are Subject to Approval of the UPES Academic Council.
      </p>
      <p className="mb-0">
        UPES Reserves the Right to Introduce/Discontinue/Modify New/Existing Programs at its Sole Discretion, 
        Without Any Prior Intimation to Any Party.
      </p>
    </footer>
  );
};

export default Footer;
